import { render, staticRenderFns } from "./water-consent-settings.vue?vue&type=template&id=29d65745&"
import script from "./water-consent-settings.vue?vue&type=script&lang=ts&"
export * from "./water-consent-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports